import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import RequirePermission from '../../components/RequirePermission';
import { PERMISSIONS } from '../../constants/permissions';
import AirportContracts from '../OperationsPortal/components/AirportContracts';

const AirportDashboardPage = () => {
    const navigate = useNavigate();

    return (
        <Layout title="Airport Branches">
            <RequirePermission permission={PERMISSIONS.view_airport_dashboard}>
                <div className="w-full">
                    <AirportContracts onBack={() => navigate('/')} />
                </div>
            </RequirePermission>
        </Layout>
    );
};

export default AirportDashboardPage;
